export enum ReportTypeCompany {
  Bailiffs = "bailiffs", //Исполнительные производства
  Revisions = "revisions", //Проверки прокуратуры
  CourtCases = "court_cases", //Арбитражные дела
  Bankruptcy = "bankruptcy", //Банкротство
  Leasing = "leasing", //Лизинг
  SuppliersBlacklist = "suppliers_blacklist", //Реестр недобросовестных поставщиков
  Contracts = "contracts", //Госконтракты
  AdditionalInfo = "additional_info", //Дополнительные сведения (санкции, 115-фз и прочее)
  Financial = "financial", //Фин отчетность
  CompanyCard = "company_card", //Карточка компании с основной информацией
  EgrulEgrip = "egrul_egrip", //ЕГРЮЛ/ЕГРИП
}

export enum ReportTypePerson {
  MainInfo = "main_info", //Базовая информация
  ExpiredPassport = "expired_passport", //Действительность паспорта
  EgripEgrul = "egrip_egrul", //ЕГРИП и ЕГРЮЛ
  DlMain = "dl_main", //Проверка ВУ
  WantedCriminal = "wanted_criminal", //Розыск
  Extremist = "extremist", //В списках террористов и экстремистов не значится
  Pledge = "pledge", //Имущество в залоге
  ExecutiveProceeding = "executive_proceeding", //Исполнительные производства
  StatusNpdNalog = "statusnpd_nalog", //Самозанятость
  MassLeaders = "massleaders", //Массовые руководители
  FedresursShort = "fedresurs_short", //Банкротство краткий отчет
}
